// extracted by mini-css-extract-plugin
export default {"primeCommentWrapper":"PrimeCommunityComment_primeCommentWrapper__soR67"};